import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import './MainApp.css';
import OverviewDashboard from './OverviewDashboard';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const MainApp = () => {
  const history = useHistory();
  const [configuredProviders, setConfiguredProviders] = useState({});
  const [loading, setLoading] = useState(true);

  const providers = [
    {
      id: 'claude',
      name: 'Claude LLM',
      description: 'Anthropic Claude API',
      icon: '🤖',
      setupRoute: '/claude_setup',
      color: '#D97757'
    },
    {
      id: 'gemini',
      name: 'Gemini',
      description: 'Google Gemini API',
      icon: '💎',
      setupRoute: '/gemini_setup',
      color: '#4285F4'
    },
    {
      id: 'openai',
      name: 'OpenAI',
      description: 'OpenAI GPT API',
      icon: '🔮',
      setupRoute: '/openai_setup',
      color: '#10A37F'
    },
    {
      id: 'grok',
      name: 'Grok',
      description: 'xAI Grok API',
      icon: '⚡',
      setupRoute: '/grok_setup',
      color: '#000000'
    }
  ];

  useEffect(() => {
    fetchConfiguredProviders();
  }, []);

  const fetchConfiguredProviders = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/keys/status`);
      setConfiguredProviders(response.data);
    } catch (error) {
      console.error('Error fetching provider status:', error);
      // Set all to not configured if error
      setConfiguredProviders({});
    } finally {
      setLoading(false);
    }
  };

  const handleSetupClick = (provider) => {
    history.push(provider.setupRoute);
  };

  const handleViewDashboards = () => {
    history.push('/select_dash');
  };

  const hasAnyConfigured = Object.values(configuredProviders).some(p => p?.configured);

  if (loading) {
    return (
      <div className="main-app">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="main-app">
      <div className="main-app-header">
        <div className="header-content">
          <h1>ZenLLM Dashboard</h1>
        </div>
        <div className="header-actions">
          {hasAnyConfigured && (
            <button onClick={handleViewDashboards} className="view-dashboards-btn">
              View Dashboards →
            </button>
          )}
        </div>
      </div>

      <div className="main-app-container">
        <div className="welcome-section">
          <h2>Your LLM Providers</h2>
          <p className="subtitle">
            Configure your API keys to start tracking usage and costs across multiple LLM providers
          </p>
        </div>

        <div className="main-content-grid">
          {/* Overview Dashboard Card - Top Left */}
          <div className="overview-card-container">
            <OverviewDashboard />
          </div>

          {/* Provider Cards - Right Side */}
          <div className="providers-grid">
            {providers.map((provider) => {
              const isConfigured = configuredProviders[provider.id]?.configured;
              const lastSync = configuredProviders[provider.id]?.last_sync;

              return (
                <div
                  key={provider.id}
                  className={`provider-card ${isConfigured ? 'configured' : ''}`}
                >
                  <div className="provider-icon" style={{ backgroundColor: `${provider.color}20` }}>
                    <span style={{ color: provider.color }}>{provider.icon}</span>
                  </div>

                  <div className="provider-info">
                    <h3>{provider.name}</h3>
                    <p>{provider.description}</p>

                    {isConfigured && lastSync && (
                      <p className="last-sync">Last synced: {new Date(lastSync).toLocaleDateString()}</p>
                    )}
                  </div>

                  <div className="provider-status">
                    {isConfigured ? (
                      <span className="status-badge configured">✓ Configured</span>
                    ) : (
                      <span className="status-badge not-configured">Not Configured</span>
                    )}
                  </div>

                  <div className="provider-actions">
                    <button
                      onClick={() => handleSetupClick(provider)}
                      className={isConfigured ? 'edit-btn' : 'setup-btn'}
                    >
                      {isConfigured ? 'Edit Keys' : 'Setup Now'}
                    </button>

                    {isConfigured && (
                      <button
                        onClick={() => history.push(`/${provider.id}`)}
                        className="view-dashboard-btn"
                      >
                        View Dashboard
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainApp;
